$(function() {
    let $body = document.querySelector('body'),
        $header = document.querySelector('.page-header'),
        $menuBtn = document.querySelector('.js-menu-btn'),
        $mobileMenu = document.querySelector('.js-mobile-menu'),
        $mobileCta = document.querySelector('.js-mob-cta'),
        $mobileOverlay = document.querySelector('.js-mob-overlay');

    //Sticky-header
    function stickyHeader() {
        if($(window).scrollTop() > 0) {
            $('.page-header').addClass('sticky');
        } else {
            $('.page-header').removeClass('sticky');
        }
    }

    if ($header) {
        $header.addEventListener('mouseover', () => {
            $header.classList.add('is-hover');
        });
        $header.addEventListener('mouseout', () => {
            $header.classList.remove('is-hover');
        });
    }

    if ($menuBtn) {
        $menuBtn.addEventListener('click', () => {
            $body.classList.toggle('ov-hidden');
            $menuBtn.classList.toggle('open');
            $mobileMenu.classList.toggle('open');
            $mobileCta.classList.toggle('open');
            $header.classList.toggle('active');
            $mobileOverlay.classList.toggle('open');
        });
    }

    //Sub menu
    if ($(window).width() <= 1262) {
        $('.mega-menu-item-has-children').children('.mega-menu-link').after(`
            <svg class="sub-menu-btn" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.85156 6.45312C5.0625 6.66406 5.41406 6.66406 5.625 6.45312L10.1953 1.90625C10.4063 1.67187 10.4062 1.32031 10.1953 1.10937L9.65625 0.570312C9.44531 0.359375 9.09375 0.359375 8.85938 0.570312L5.25 4.17969L1.61719 0.570312C1.38281 0.359375 1.03125 0.359375 0.820313 0.570312L0.28125 1.10938C0.0703125 1.32031 0.0703125 1.67188 0.28125 1.90625L4.85156 6.45312Z" fill="white"/>
            </svg>
        `);
        $('.mega-menu-item-has-children > .mega-sub-menu').addClass('main-sub-menu');
        $('.main-sub-menu').slideUp();

        $('.sub-menu-btn').on('click', function H(e) {
            e.preventDefault();
            $(this).siblings('.main-sub-menu').slideToggle();
            $(this).toggleClass('rotate');
        });
    }

    document.addEventListener('scroll', () => {
        stickyHeader();
    });
});